export enum CarLinks {
  LOGIN = 'https://jobauto.one.finn.auto/p/log-in',
  REGISTER_LINK = 'https://www.finn.com/de-DE/b2b/job-auto-fur-arbeitgeber/probonio',
  MAIL = 'mailto:jobauto@finn.com',
  SITE = 'https://www.finn.com/de-DE/b2b/job-auto',
  FAQ = 'https://support-jobauto.finn.com/hc/de',
}
